import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetPartnerIDService {

  constructor(private http: HttpClient) { }

  async getPartnerID(query) {
    try {
      let response = await this.http
        .get(`${appApiResources.getByPartnerID}?${query}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }
}
